import React, { useEffect, useState } from "react";
import { Grid, Box, Typography, Avatar, Radio } from "@mui/material";
import "./FeedbackEditActionModal.css";
import CustomModal from "../../CustomModal/CustomModal";
import ModalFooter from "../../CustomModal/ModalFooter";
import ModalHeader from "../../CustomModal/ModalHeader";
import CustomTextField from "../../../components/CustomTextField/CustomTextField";
import CompDirection from "../../../themes/CompDirection";
import { fonts } from "../../../themes/themes";
import CustomAutoComplete from "../../../components/CustomAutoComplete/CustomAutoComplete";
interface ModalProps {
  isModalOpen?: boolean;
  closeModal: any;

  trans?: any;
}

const FeedbackDetailModalPresenter = ({
  isModalOpen,
  closeModal,

  trans,
}: ModalProps) => {
  return (
    <CustomModal isModalOpen={isModalOpen} modalHeight="50vh" modalWidth="20vw">
      <ModalHeader
        modal={{ modal_title: trans("Edit Feedback") }}
        closeModal={closeModal}
      />
      <CompDirection>
        <Grid
          spacing={2}
          container
          sx={{
            marginTop: "15px",
          }}
        >
          <Grid item xs={12}>
            <Box
              style={{
                border: "1px solid #0000001F",
                padding: "1em",
                borderRadius: "7px",
              }}
            >
              <Typography
                style={{
                  color: "#575757",
                  fontFamily: fonts.fontFamily,
                  fontSize: "1em",
                  fontWeight: "bold",
                }}
              >
                Feedback For
              </Typography>
              <Box
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  width: "100%",
                  marginTop: "0.5em",
                }}
              >
                <Box
                  style={{
                    border: "1px solid #D8D8D8",
                    display: "flex",
                    alignItems: "center",

                    padding: "0.2em",
                    borderRadius: "5px",
                    width: "40%",
                  }}
                >
                  <Radio />
                  <Typography
                    style={{
                      color: "black",
                      fontFamily: fonts.fontFamily,
                      fontSize: "0.75em",
                      fontWeight: "bold",
                    }}
                  >
                    Goals
                  </Typography>
                </Box>
                <Box
                  style={{
                    border: "1px solid #D8D8D8",
                    display: "flex",
                    alignItems: "center",
                    padding: "0.2em",
                    borderRadius: "5px",
                    width: "40%",
                  }}
                >
                  <Radio />
                  <Typography
                    style={{
                      color: "black",
                      fontFamily: fonts.fontFamily,
                      fontSize: "0.75em",
                      fontWeight: "bold",
                    }}
                  >
                    KPIs
                  </Typography>
                </Box>
              </Box>
              <Box style={{ marginTop: "1em" }}>
                <CustomAutoComplete label="Select Goal" />
              </Box>
              <Box style={{ marginTop: "1em" }}>
                <CustomAutoComplete label="Select Task" />
              </Box>
              <Box style={{ marginTop: "1em" }}>
                <CustomTextField type="string" label="Feedback" />
              </Box>
            </Box>
          </Grid>
        </Grid>
      </CompDirection>

      <Box style={{ marginTop: "35px" }} />
      <ModalFooter
        onClickCancel={() => {
          closeModal();
        }}
      />
    </CustomModal>
  );
};

export default FeedbackDetailModalPresenter;
